"use strict";

global.$ = global.jQuery = require('jquery');
global._ = window._ = require('underscore');
global.$.fn.reverse = [].reverse;

window.easings = {};
window.easings.ease = [0.25, 0.46, 0.45, 0.94];
window.easings.andrew = [0.77, 0, 0.175, 1];
window.easings.feebles1 = [.8,.03,.25,1];
window.easings.feebles2 = [.72,.01,.25,1];
window.easings.ease2 = [.48,.1,.48,.9];

var validation = require('jquery-validation');
var PubSub = require("underpub-js");
var Pjax = require("pjax");
var Uri = require("urijs");

var jqueryUi = require('jquery-ui');
var draggable = require('jquery-ui/ui/widgets/draggable');

var Sitewide = require("./classes/Sitewide");
var ComponentsLoader = require("./classes/ComponentsLoader");
//var {Amplify} = require("../../../vendor/authenticff/authentic-amplify/frontend/scripts/main.js");

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
  this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();

window.App = {};

// setting this to true will enable PJAX for page transitions sitewide
App.usePjax = false;

App.documentOnLoad = function() {

  var components = [
    // components
    // content
    {handle: "[data-content-1]", require: require("../components/molecules/content/content1/Content1")},
    {handle: "[data-content-2]", require: require("../components/molecules/content/content2/Content2")},
    {handle: "[data-content-3]", require: require("../components/molecules/content/content3/Content3")},
    {handle: "[data-content-4]", require: require("../components/molecules/content/content4/Content4")},
    {handle: "[data-content-image-1]", require: require("../components/molecules/content/contentImage1/ContentImage1")},
    {handle: "[data-content-image-2]", require: require("../components/molecules/content/contentImage2/ContentImage2")},
    {handle: "[data-content-image-3]", require: require("../components/molecules/content/contentImage3/ContentImage3")},
    // cta
    {handle: "[data-cta-1]", require: require("../components/molecules/cta/cta1/Cta1")},
    {handle: "[data-cta-2]", require: require("../components/molecules/cta/cta2/Cta2")},
    {handle: "[data-cta-email-1]", require: require("../components/molecules/cta/ctaEmail1/CtaEmail1")},
    // forms
    {handle: "[data-contact-1]", require: require("../components/molecules/forms/contact1/Contact1")},
    // gallery
    {handle: "[data-gallery-1]", require: require("../components/molecules/gallery/gallery1/Gallery1")},
    {handle: "[data-gallery-2]", require: require("../components/molecules/gallery/gallery2/Gallery2")},
    {handle: "[data-gallery-3]", require: require("../components/molecules/gallery/gallery3/Gallery3")},
    {handle: "[data-gallery-4]", require: require("../components/molecules/gallery/gallery4/Gallery4")},
    {handle: "[data-gallery-5]", require: require("../components/molecules/gallery/gallery5/gallery5")},
    {handle: "[data-gallery-6]", require: require("../components/molecules/gallery/gallery6/gallery6")},
    {handle: "[data-gallery-7]", require: require("../components/molecules/gallery/gallery7/gallery7")},
    {handle: "[data-matterport-gallery]", require: require("../components/molecules/gallery/matterportGallery/matterportGallery")},
    // icons
    {handle: "[data-icons-1]", require: require("../components/molecules/icons/icons1/Icons1")},
    // image cards
    {handle: "[data-image-cards-1]", require: require("../components/molecules/imageCards/imageCards1/ImageCards1")},
    // key intro
    {handle: "[data-key-intro-1]", require: require("../components/molecules/keyIntro/keyIntro1/KeyIntro1")},
    // map
    {handle: "[data-map-1]", require: require("../components/molecules/map/map1/Map1")},
    {handle: "[data-poi-map]", require: require("../components/molecules/map/poiMap/PoiMap")},
    // misc
    {handle: "[data-three-sixty-viewer]", require: require("../components/molecules/misc/threeSixtyViewer/ThreeSixtyViewer")},
    // modal
    {handle: "[data-modal-ar-1]", require: require("../components/molecules/modal/modalAr1/ModalAr1")},
    {handle: "[data-modal-image-gallery]", require: require("../components/molecules/modal/modalImageGallery/ModalImageGallery")},
    {handle: "[data-modal-video]", require: require("../components/molecules/modal/modalVideo/modalVideo")},
    // navigation
    {handle: "[data-mobile-nav-overlay]", require: require("../components/molecules/navigation/mobileNavOverlay/MobileNavOverlay")},
    // stats
    {handle: "[data-stats-1]", require: require("../components/molecules/stats/stats1/Stats1")},
    {handle: "[data-stats-2]", require: require("../components/molecules/stats/stats2/Stats2")},
    // timeline
    {handle: "[data-timeline-1]", require: require("../components/molecules/timeline/timeline1/Timeline1")},
    {handle: "[data-timeline-2]", require: require("../components/molecules/timeline/timeline2/Timeline2")},
    
    // elements
    {handle: "[data-key-info-section]", require: require("../components/elements/keyInfoSection/KeyInfoSection")},

    // atoms
    {handle: ".button-primary", require: require("../components/atoms/buttonPrimary/ButtonPrimary")},

    {handle: "[data-hero-homepage]", require: require("../components/molecules/hero/heroHomepage/heroHomepage")},
  ];

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({components: components});
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

};

// document ready

$(document).ready(function(){

  // call sitewide here, because we only want to init this once
  var sitewide = new Sitewide();
  sitewide.init();

  App.documentOnLoad();

});

